"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.evaluateCondition = exports.default = void 0;

var _find2 = _interopRequireDefault(require("lodash/find"));

var _isArray2 = _interopRequireDefault(require("lodash/isArray"));

var _isString2 = _interopRequireDefault(require("lodash/isString"));

var _toString2 = _interopRequireDefault(require("lodash/toString"));

var _isNumber2 = _interopRequireDefault(require("lodash/isNumber"));

var _intersection2 = _interopRequireDefault(require("lodash/intersection"));

var _escapeRegExp2 = _interopRequireDefault(require("lodash/escapeRegExp"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var operators = {
  number: [{
    code: '<',
    title: '<',
    isValue: true,
    valueType: 'number',
    evaluate: function evaluate(dataConnector, value) {
      if (!(0, _isNumber2.default)(dataConnector)) {
        return false;
      }

      return dataConnector < value;
    }
  }, {
    code: '<=',
    title: '<=',
    isValue: true,
    valueType: 'number',
    evaluate: function evaluate(dataConnector, value) {
      if (!(0, _isNumber2.default)(dataConnector)) {
        return false;
      }

      return dataConnector <= value;
    }
  }, {
    code: '=',
    title: '=',
    isValue: true,
    valueType: 'number',
    evaluate: function evaluate(dataConnector, value) {
      if (!(0, _isNumber2.default)(dataConnector)) {
        return false;
      }

      return dataConnector === value;
    }
  }, {
    code: '>=',
    title: '>=',
    isValue: true,
    valueType: 'number',
    evaluate: function evaluate(dataConnector, value) {
      if (!(0, _isNumber2.default)(dataConnector)) {
        return false;
      }

      return dataConnector >= value;
    }
  }, {
    code: '>',
    title: '>',
    isValue: true,
    valueType: 'number',
    evaluate: function evaluate(dataConnector, value) {
      if (!(0, _isNumber2.default)(dataConnector)) {
        return false;
      }

      return dataConnector > value;
    }
  }],
  string: [{
    code: 'defined',
    title: 'should be defined',
    evaluate: function evaluate(dataConnector, value) {
      if (!(0, _isString2.default)(dataConnector)) {
        return false;
      }

      return dataConnector.length > 0;
    }
  }, {
    code: 'undefined',
    title: 'should be undefined',
    evaluate: function evaluate(dataConnector, value) {
      if (!(0, _isString2.default)(dataConnector)) {
        return true;
      }

      return dataConnector.length === 0;
    }
  }, {
    code: 'equals',
    title: 'equals',
    isValue: true,
    valueType: 'string',
    evaluate: function evaluate(dataConnector, value) {
      if (!(0, _isString2.default)(dataConnector)) {
        return false;
      }

      return dataConnector === value;
    }
  }, {
    code: 'doesntEqual',
    title: "doesn't equal",
    isValue: true,
    valueType: 'string',
    evaluate: function evaluate(dataConnector, value) {
      if (!(0, _isString2.default)(dataConnector)) {
        return true;
      }

      return dataConnector !== value;
    }
  }, {
    code: 'includes',
    title: 'includes',
    isValue: true,
    valueType: 'string',
    evaluate: function evaluate(dataConnector, value) {
      if (!(0, _isString2.default)(dataConnector)) {
        return false;
      }

      return dataConnector.includes(value);
    }
  }, {
    code: 'doesntInclude',
    title: "doesn't include",
    isValue: true,
    valueType: 'string',
    evaluate: function evaluate(dataConnector, value) {
      if (!(0, _isString2.default)(dataConnector)) {
        return true;
      }

      return !dataConnector.includes(value);
    }
  }, {
    code: 'startsWith',
    title: 'starts with',
    isValue: true,
    valueType: 'string',
    evaluate: function evaluate(dataConnector, value) {
      if (!(0, _isString2.default)(dataConnector)) {
        return false;
      }

      var regex = new RegExp('^' + (0, _escapeRegExp2.default)(value), 'i');
      return regex.test(dataConnector);
    }
  }, {
    code: 'endsWith',
    title: 'ends with',
    isValue: true,
    valueType: 'string',
    evaluate: function evaluate(dataConnector, value) {
      if (!(0, _isString2.default)(dataConnector)) {
        return false;
      }

      var regex = new RegExp((0, _escapeRegExp2.default)(value) + '$', 'i');
      return regex.test(dataConnector);
    }
  }, {
    code: '<',
    title: '< (as a number)',
    isValue: true,
    valueType: 'number',
    evaluate: function evaluate(dataConnector, value) {
      var n = Number(dataConnector);

      if (Number.isNaN(n) || dataConnector === null) {
        return false;
      }

      return n < value;
    }
  }, {
    code: '<=',
    title: '<= (as a number)',
    isValue: true,
    valueType: 'number',
    evaluate: function evaluate(dataConnector, value) {
      var n = Number(dataConnector);

      if (Number.isNaN(n) || dataConnector === null) {
        return false;
      }

      return n <= value;
    }
  }, {
    code: '>=',
    title: '>= (as a number)',
    isValue: true,
    valueType: 'number',
    evaluate: function evaluate(dataConnector, value) {
      var n = Number(dataConnector);

      if (Number.isNaN(n) || dataConnector === null) {
        return false;
      }

      return n >= value;
    }
  }, {
    code: '>',
    title: '> (as a number)',
    isValue: true,
    valueType: 'number',
    evaluate: function evaluate(dataConnector, value) {
      var n = Number(dataConnector);

      if (Number.isNaN(n) || dataConnector === null) {
        return false;
      }

      return n > value;
    }
  }, {
    code: 'regex',
    title: 'regex',
    isValue: true,
    valueType: 'string',
    evaluate: function evaluate(dataConnector, value) {
      if (!(0, _isString2.default)(dataConnector)) {
        return false;
      }

      var regex = new RegExp(value, 'i');
      return regex.test(dataConnector);
    }
  }],
  array: [{
    code: 'includes',
    title: 'includes one or more',
    isValue: true,
    valueType: 'select',
    evaluate: function evaluate(dataConnector, value) {
      if (!(0, _isArray2.default)(dataConnector)) {
        return false;
      }

      if (!(0, _isArray2.default)(value)) {
        value = [value];
      }

      return (0, _intersection2.default)(dataConnector.map(_toString2.default), value.map(_toString2.default)).length > 0;
    }
  }, {
    code: 'doesntInclude',
    title: "doesn't include",
    isValue: true,
    valueType: 'select',
    evaluate: function evaluate(dataConnector, value) {
      if (!(0, _isArray2.default)(dataConnector)) {
        return true;
      }

      if (!(0, _isArray2.default)(value)) {
        value = [value];
      }

      return (0, _intersection2.default)(dataConnector.map(_toString2.default), value.map(_toString2.default)).length === 0;
    }
  }]
};
var _default = operators;
exports.default = _default;

var evaluateCondition = function evaluateCondition(_ref) {
  var dataConnector = _ref.dataConnector,
      type = _ref.type,
      operator = _ref.operator,
      value = _ref.value;
  var evaluate = (0, _find2.default)(operators[type], {
    code: operator
  }).evaluate;
  return evaluate(dataConnector, value);
};

exports.evaluateCondition = evaluateCondition;